<template>
    <div class="headshot">
      <div class="image"><img src="../../assets/img/headshot.jpg" alt="Andy MacPherson"/></div>
    </div>
</template>

<script>
    export default {
      name: 'Headshot',
      props: {
        msg: String,
      }
    }
</script>

<style scoped>
</style>
